<template>
  <div>
<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Notification</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >

      <!-- COMMENT2 -->
      <!-- <div style="width: 100%" class="mt-3">
        <CCol sm="12" class="mt-3">
            <span @click="GoToPageHelp()">
            <img
              src="../assets/img/iconhelp.png"
              width="45px"
              class="float-left mt-3"
            />
          </span>
          <span @click="GoToPageFindTutor()">
            <img
              src="../assets/img/iconAdd.png"
              width="40px"
              class="float-right mt-3"
            />
          </span>
          <span class="mt-5 mb-5"> </span>
            <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div> -->
      <!-- COMMENT2 -->
      
      <!-- COMMENT START HERE -->
      <div style="width: 100%">
        <CCol sm="12" class="mt-1">
          <CRow>
            <CCol>
          <span class="float-right mt-3" @click="OpenPopupInfo()">
            <label>Group of two</label> &nbsp;
            <img src="../assets/img/arrow.png" width="35px"/>
          </span>
            </CCol>
          </CRow>
          
          <span class="float-right mt-1" @click="GoToPageFindTutor()">
            <label>One-to-one</label> &nbsp;
            <img src="../assets/img/iconAdd.png" width="35px"/>
          </span>

          <span @click="GoToPageHelp()">
            <img
              src="../assets/img/iconhelp1.png"
              width="40px"
              class="float-left mt-1"
            />
          </span>
          
          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
      <!-- COMMENT END HERE -->
    </div>
    
    <CCard class="custom-card h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin m-0 p-0">
            <h5 class="text-left mt-2 d-flex d-sm-none text-black bold">
              Parent Messages <br />
            </h5>
            <div class="mt-2">
              <img
                src="../assets/img/iconInfo.png"
                width="20px"
                height="20px"
                class="mr-2"
              />
              Your Find Tutor Request History This is a list of published Jobs
              submitted from Find Tutor. “Open Job” means that your request is
              still awaiting a response from any tutor. "Job Confirmed" means
              the class has been created and a tutor has been appointed by you.
              Please note that each job applied from the tutor, is placed in the
              notification screen.
            </div>
            <!-- <CCol sm="12" lg="12" class="mt-2">
              <CRow>
                <span sm="4" lg="4" @click="RefreshData()"
                  ><CCard style="display:inline-block" class="p-1"
                    ><img
                      style="width:25px"
                      src="../assets/img/menu.png"
                      class="mr-1"
                    />
                    <strong>All</strong></CCard
                  >
                </span>
                <span sm="4" lg="4" @click="ApplyOpenJob()" class="ml-2"
                  ><CCard style="display:inline-block" class="p-1"
                    ><img
                      style="width:25px"
                      src="../assets/img/offer.png"
                      class="mr-1"
                    />
                    <strong>Open Job</strong></CCard
                  ></span
                >
                <span sm="4" lg="4" @click="ApplyConfirmJob()" class="ml-2"
                  ><CCard style="display:inline-block" class="p-1"
                    ><img
                      style="width:25px"
                      src="../assets/img/confirm.png"
                      class="mr-1"
                    /><strong>Job confirmed</strong></CCard
                  ></span
                >
              </CRow>
            </CCol> -->

            <!-- COMMENT2 -->
            <!-- <CCol sm="12" lg="12" class="mt-4" style="display: flex;">
              <span
                sm="4"
                lg="4"
                @click="ApplyOpenJob()"
                style="flex:1;"
                ><CCard
                  style="border: 2px solid #009688; border-radius:10px;"
                  class="p-2"
                >
                  <CCol>
                    <img
                      style="width:25px"
                      src="../assets/img/offer.png"
                      class="mr-2"
                    />
                    <strong>Open Job</strong>
                  </CCol>
                </CCard></span
              >
              <span
                sm="4"
                lg="4"
                @click="ApplyConfirmJob()"
                class="ml-2"
                style="flex:1;"
                ><CCard
                  style="border: 2px solid #009688; border-radius:10px;"
                  class="p-2"
                >
                  <CCol>
                    <img
                      style="width:25px"
                      src="../assets/img/confirm.png"
                      class="mr-2"
                    /><strong>Job confirmed</strong>
                  </CCol>
                </CCard></span
              >
            </CCol> -->
            <!-- COMMENT2 -->
            
            <!-- COMMENT START HERE -->
            <CRow class="mt-3">
              <CCol class="col-6">
              <CCard
                style="
                  border: 2px solid #009688; border-radius:10px; 
                  padding-left: 0px;
                  padding-top: 10px;
                  padding-bottom: 10px;
                "              
                @click="ApplyOpenJob()"
              >
                <CCol>
                  <img
                    style="width:25px"
                    src="../assets/img/offer.png"
                    class="mr-2"
                  />
                  <strong>Open Job</strong>
                </CCol>
              </CCard>
              </CCol>
              <CCol class="col-6">
              <CCard
                style="
                  border: 2px solid #009688; border-radius:10px; 
                  padding-left: 0px;
                  padding-top: 10px;
                  padding-bottom: 10px;
                "              
                @click="ApplyOpenJob()"
              >
                <CCol>
                  <img
                    style="width:25px;"
                    src="../assets/img/confirm.png"
                    class="mr-2"
                  />
                  <strong>Job Confirmed</strong>
                </CCol>
              </CCard>
              </CCol>
            </CRow>
            <!-- COMMENT END HERE -->
            

            <!-- ni kalau takde data -->
            <CCard v-if="!FindTutorDt.length">
              <div class="mt-5 text-center mb-5">
                <img src="../assets/img/nodata.png" width="120px" />
                <br />
                No notification yet
              </div>
            </CCard>
            <!-- end -->

            <!-- condition group atau one-to-one -->
            <div v-for="item in FindTutorDt" v-bind:key="item.Id"> 
              <div v-if="item.TypeOfGroup == true">
                <!-- condition check grouping -->
                <!-- <div v-for="group in groupcheck" v-bind:key="group.FindTutorId">-->
                  <div v-if="item.IsPartner == true"> 
                    <CCard class="p-2 mt-2" style="border: 2px solid #99A3A4; border-radius:10px;">
                      <CCol>
                        <CRow sm="10" lg="10" class=" d-flex">
                          <CCol sm="12" lg="12">
                            <CRow>
                              <CCol sm="12" lg="12">
                                <img
                                  width="30"
                                  height="30"
                                  src="../assets/img/joboffer.jpg"
                                  class="mb-2"
                                  style="border: 1px solid #99A3A4; border-radius:10px;"
                                />
                                <strong class="ml-2 mb-2"
                                  >Job ({{ item.FindTutorId }})</strong
                                ><strong class="float-right">
                                  {{ item.CreatedTime | moment("dddd, MMMM Do YYYY, h:mm a")}}</strong
                                >
                                <br />
                                <label>{{ item.Description }}</label>
                                <br />
                                <strong> {{ item.StudentName }} </strong>
                                <br />
                                - subject <strong> {{ item.SubjectName }} </strong>
                                <br />
                                - grade <strong> {{ item.GradeName }} </strong> 
                                <br />
                                - type <strong> Group Of Two </strong>
                                <br />
                                <label v-if="item.scheduleID < 0"
                                  >Job Status
                                  <CBadge color="success"> Open</CBadge></label>
                                <label v-else
                                  >Job Status
                                  <CBadge color="danger"> Closed</CBadge></label>
                                <br />
                              </CCol>
                            </CRow>
                          </CCol>
                        </CRow>
                      </CCol>
                    </CCard>
                  </div>
                <!-- </div> -->
              </div>

              <div v-else>
                <CCard class="p-2 mt-2" style="border: 2px solid #99A3A4; border-radius:10px;">
                  <CCol>
                    <CRow sm="10" lg="10" class=" d-flex">
                      <CCol sm="12" lg="12">
                        <CRow>
                          <CCol sm="12" lg="12">
                            <img
                              width="30"
                              height="30"
                              src="../assets/img/joboffer.jpg"
                              class="mb-2"
                              style="border: 1px solid #99A3A4; border-radius:10px;"
                            />
                            <strong class="ml-2 mb-2"
                              >Job ({{ item.FindTutorId }})</strong
                            ><strong class="float-right">
                              {{ item.CreatedTime | moment("dddd, MMMM Do YYYY, h:mm a")}}</strong
                            >
                            <br />
                            <label>{{ item.Description }}</label>
                            <br />
                            <strong> {{ item.StudentName }} </strong>
                            <br />
                            - subject <strong> {{ item.SubjectName }} </strong>
                            <br />
                            - grade <strong> {{ item.GradeName }} </strong> 
                            <br />
                            - type <strong> One-to-One </strong>
                            <br />
                            <label v-if="item.scheduleID < 0"
                              >Job Status
                              <CBadge color="success"> Open</CBadge></label
                            >
                            <label v-else
                              >Job Status
                              <CBadge color="danger"> Closed</CBadge></label
                            >
                            <br />
                          </CCol>
                        </CRow>
                      </CCol>
                    </CRow>
                  </CCol>
                </CCard>
              </div>
            </div>

              <!-- <CCol sm="12" lg="12" class="m-2">
                <CRow>
                  <article>
                    <div>
                      <CCol sm="12" lg="12">
                        <img
                          width="30"
                          height="30"
                          src="../assets/img/joboffer.jpg"
                          style="border: 1px solid #99A3A4; border-radius:10px;"
                        />
                        <strong class="ml-2 mb-2"
                          >Job ({{ item.FindTutorId }})</strong
                        ><strong class="float-right">
                          {{ item.CreatedTime }}</strong
                        >
                      </CCol>

                     <br />
                      <label>{{ item.Description }}</label>
                      <br />
                      - subject <strong> {{ item.SubjectName }} </strong>
                      <br />
                      - grade <strong> {{ item.GradeName }} </strong> <br />
                      <label v-if="item.Status === false"
                        >Job Status
                        <CBadge color="success"> Open</CBadge></label
                      >
                      <label v-else
                        >Job Status
                        <CBadge color="danger"> Closed</CBadge></label
                      >
                      <br />
                    </div>
                  </article>
                </CRow>
              </CCol> 
            </CCard>-->
            <CCard
              v-for="(item, index) in FindTutorDt"
              v-bind:key="item.Id"
              class="mt-2 p-2 d-none d-sm-flex"
            >
              <CCol sm="12" lg="12" v-if="item.Type == 3">
                <CRow @click="GoToPageNotificationResponse(index)">
                  <CCol sm="1" lg="1">
                    <div class="p-2">
                      <img
                        width="50"
                        height="50"
                        src="../assets/img/acceptjob.jpg"
                      />
                    </div>
                  </CCol>
                  <CCol class="float-right">
                    <CRow>
                      <CCol sm="9" lg="9">
                        <strong>Job ({{ item.FindTutorId }})</strong>
                        <br />
                        Class
                        <CBadge color="primary">{{ item.SubjectName }}</CBadge>
                        <br />
                        <label>{{ item.Description }}</label>
                        <br />
                      </CCol>
                      <CCol sm="3" lg="3">
                        <strong class="mt-5">
                          <i>{{ item.CreatedTime }}</i></strong
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>

              <CCol sm="12" lg="12" v-else>
                <CRow v-if="item.Status === true">
                  <CCol sm="1" lg="1">
                    <div class="p-2">
                      <img
                        width="50"
                        height="50"
                        src="../assets/img/joboffer.jpg"
                      />
                    </div>
                  </CCol>
                  <CCol class="float-right">
                    <CRow>
                      <CCol sm="9" lg="9">
                        <strong>Job ({{ item.FindTutorId }})</strong>
                        <br />
                        Class
                        <CBadge color="primary">{{ item.SubjectName }}</CBadge>
                        <br />
                        <label>{{ item.Description }}</label>

                        <br />
                        <label v-if="item.scheduleID < 0"
                          >Job Status
                          <CBadge color="success"> Open</CBadge></label
                        >
                        <label v-else
                          >Job Status
                          <CBadge color="danger"> Closed</CBadge></label
                        >
                        <br />
                      </CCol>
                      <CCol sm="3" lg="3">
                        <strong class="mt-5">
                          <i>{{ item.CreatedTime }}</i></strong
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>

                <CRow v-else @click="GoToPageResponse(index)">
                  <CCol sm="1" lg="1">
                    <div class="p-2">
                      <img
                        width="50"
                        height="50"
                        src="../assets/img/joboffer.jpg"
                      />
                    </div>
                  </CCol>
                  <CCol class="float-right">
                    <CRow>
                      <CCol sm="9" lg="9">
                        <strong>Job ({{ item.FindTutorId }})</strong>
                        <br />
                        Class
                        <CBadge color="primary">{{ item.SubjectName }}</CBadge>
                        <br />
                        <label>{{ item.Description }}</label>

                        <br />
                        <label v-if="item.scheduleID < 0"
                          >Job Status
                          <CBadge color="success"> Open</CBadge></label
                        >
                        <label v-else
                          >Job Status
                          <CBadge color="danger"> Closed</CBadge></label
                        >
                        <br />
                      </CCol>
                      <CCol sm="3" lg="3">
                        <strong class="mt-5">
                          <i>{{ item.CreatedTime }}</i></strong
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CCard>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>

    <CModal title="Student List" size="sm" color="info" :show.sync="ChildList">
      <CCol
          v-for="item in StudentList"
          v-bind:key="item.Id"
          class="justify-content-center"
        >
          <br />
          <CRow
            id="sb"
            sm="8"
            lg="8"
            style="
              border-radius: 8px;
              border: 1px solid #009688;
              background: #ebedef;
            "
            class="m-0 pt-1 col-12 box-shadow"
            @click="GoToPageWaitingList(item.Id)"
          >
            <CCol class="col-3 pt-2 pb-2">
                <img
                  src="../assets/img/user.png"
                  width="50px"
                  height="50px"
                  class="box-shadow"
                  style="border-radius: 50%; border: 1px solid #eee"
                />
            </CCol>
            <CCol class="col-9 text-left mt-3">
              <h5 class="ml-2 mr-2 text-black custom-font">
                <strong> {{ item.Name }}</strong>
              </h5>
            </CCol>
          </CRow>
        </CCol>
        <template class="modal-footer" hidden="true" #footer>
        <span></span>
      </template>  
    </CModal>

  </div>
</template>


<script>
import Vue from "vue";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      profiles: [],
      notify: [],
      SearchQuery: "A student offer tutor job for you",
      SearchQueryTutor: "I accept you as Tutor",
      FindTutorDt: [],
      check: "",
      StudentList: [],
      ChildList : false,
      groupcheck: [],
    };
  },
  async mounted() {
    //this.GetGrouping();
    await this.GetFindTutorDetails();
    await this.GetCheckingJob();
    this.GetListChild();

  },
  methods: {
    // async GetGrouping() {
    //   this.$API
    //     .get(
    //       this.$Grouping + 
    //         "?findTutorId=" + this.$route.query.findTutorId +
    //         "?WaitingListId=" + this.$route.query.WaitingListId +
    //         "?StudentId=" + this.$route.query.StudentId, 
    //         {
    //           withCredentials: true
    //         }
    //     )
    //     .then(response => {
    //       if (response.status == 200 && response.data != null) {
    //         this.groupcheck = response.data;
    //         console.log("masuk");
    //       }
    //     });
    // },

    async GetFindTutorDetails() {
      this.$API
        .get(
          this.$FindtutorFullDetails + "?userId=" + this.$route.query.userID,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.FindTutorDt = response.data;
            this.profiles = response.data;
          }
        });
    },
    OpenChecking(index) {
      this.findTutorId = this.profiles[index].FindTutorId;
      this.GetCheckingJob(this.findTutorId);

      console.log("t" + this.findTutorId);
    },
    async GetCheckingJob(findTutorId) {
      this.$API
        .get(this.$CheckStatusJob + "?tutorId=" + this.findTutorId, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.check = response.data;
          }
        });
    },
    ApplyOpenJob: function() {
      var arr = this.profiles;
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, function(o) {
          //return o.Status == false;
          return o.scheduleID < 0;
        });

        this.FindTutorDt = result;
      }
    },

    ApplyConfirmJob: function() {
      var arr = _.orderBy(this.profiles, ["Description"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        // const result = _.filter(arr, ({ Description }) =>
        //   _.some([
        //     _.includes(!Description || Description.toLowerCase(), [
        //       this.SearchQueryTutor.toLowerCase("")
        //     ])
        //   ])
        // );
        const result = _.filter(arr, function(o) {
          //return o.Status == true;
          return o.scheduleID > 0;
        });
        this.FindTutorDt = result;
      }
    },
    
    OpenPopupInfo() {
      this.ChildList = true;
    },
    async GetListChild() {
      this.$API
        .get(this.$ListChild + "?userID=" + this.$route.query.userID, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.StudentList = response.data;
            console.log(this.StudentList);
            this.Id = this.$route.query.Id;
          }
        });
    },
    GoToPageWaitingList(Id) {
      this.$router.push(
        "/ListWaiting?userID=" + 
          this.$route.query.userID +
        "&studentId=" + 
            Id,
      );
    },
    GoToPageFindTutor() {
      this.$router.push(
        "/CreateNewFindTutor?userID=" + 
        this.$route.query.userID
      );
    },
    GoToPageHelp() {
      this.$router.push("/Guide");
    },
  }
};
</script>
